<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content>
    <div [innerHtml]="message"></div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <forge-button variant="raised" mat-dialog-close telemetry="Submission-Save">
        {{okLabel}}
    </forge-button>
</mat-dialog-actions>
